/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.25.0 of "Settings"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */
import type { AppearanceMode } from '../models/AppearanceMode';
import type { GetSettingsResponse } from '../models/GetSettingsResponse';

import { clientOptionsFactory } from '../clientOptions';
import { apiClientRequest as __request } from '@api-client/base';
import type { ClientOptions } from '@api-client/base';

export class SettingsService {

    /**
     * Get user settings.
     * Get GroupAPI settings data with George-owned setting-related data for the authorized user.
     *
     * @returns GetSettingsResponse GroupAPI settings data with George-owned settings-related data for the authorized user.
     *
     * @throws ApiError
     */
    public static getPublicSettings(
        clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
        public static getPublicSettings(
            clientOptionsOverride?: Partial<ClientOptions>): Promise<GetSettingsResponse>;
            public static getPublicSettings(
                clientOptionsOverride: Partial<ClientOptions> = {}
            ) {
                return __request(
                    {...clientOptionsFactory.get()(), ...clientOptionsOverride},
                    {
                        method: 'GET',
                        url: '/public/settings',
                    });
                }

                /**
                 * Update user settings.
                 * Update the George-owned user settings data for the authorized user.
                 *
                 * @returns void
                 * @throws ApiError
                 */
                public static patchPublicSettings({
                    requestBody,
                }: {
                    requestBody?: {
                        appearanceMode?: AppearanceMode;
                    }
                },
                clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
                public static patchPublicSettings({
                    requestBody,
                }: {
                    requestBody?: {
                        appearanceMode?: AppearanceMode;
                    }
                },
                clientOptionsOverride?: Partial<ClientOptions>): Promise<void>;
                public static patchPublicSettings({
                    requestBody
                }: {
                    requestBody?: {
                        appearanceMode?: AppearanceMode;
                    },
                },
                clientOptionsOverride: Partial<ClientOptions> = {}
            ) {
                return __request(
                    {...clientOptionsFactory.get()(), ...clientOptionsOverride},
                    {
                        method: 'PATCH',
                        url: '/public/settings',
                        body: requestBody,
                        mediaType: 'application/json',
                    });
                }

            }
